import {isDesktop} from "../../webpack/modules/devices";
import {customEvent, windowScrollEvent} from "../../webpack/modules/events";

if (document.querySelector('.left-menu-v2')) {
    if (isDesktop()) {
        calculateLeftMenuHeight();

        let headerMessagesVisible = false;
        windowScrollEvent(function() {
            let headerMessages = document.querySelector('.header-messages');
            if (!headerMessages) return;
            let rect = headerMessages.getBoundingClientRect();
            let currentHeaderMessagesVisible = rect.top < window.innerHeight && rect.bottom > 0;

            //RECALCULATE LEFT MENU HEIGHT ONLY IF VISIBILITY CHANGED
            if (headerMessagesVisible !== currentHeaderMessagesVisible) {
                headerMessagesVisible = currentHeaderMessagesVisible;
                if (headerMessagesVisible) calculateLeftMenuHeight();
                else calculateLeftMenuHeightWithoutMessages();
            }
        });
    }
}

customEvent('show.bs.offcanvas', '.left-menu-v2', false, function(leftMenu) {
    if (isDesktop()) {
        setTimeout(function() {
            let backdrop = document.querySelector('.offcanvas-backdrop');
            backdrop.style.height = leftMenu.style.height;
            backdrop.style.top = 'inherit';
            backdrop.style.bottom = '0';
        }, 1);
    }
});

function calculateLeftMenuHeight()
{
    document.querySelectorAll('.left-menu-v2').forEach(function(leftMenu) {
        let header = document.querySelector('header');
        let headerMessages = document.querySelector('.header-messages');
        let headerHeight = header.offsetHeight;

        if (headerMessages) headerHeight += headerMessages.offsetHeight;
        leftMenu.style.height = (window.innerHeight - headerHeight) + 'px';
    });
}

function calculateLeftMenuHeightWithoutMessages()
{
    document.querySelectorAll('.left-menu-v2').forEach(function(leftMenu) {
        let header = document.querySelector('header');
        let headerHeight = header.offsetHeight;
        leftMenu.style.height = (window.innerHeight - headerHeight) + 'px';
    });
}